import CryptoJS from 'crypto-js';
/**
 * aes 解密方法
 */
export const decrypt = (str, k, i) => {
    let encryptedHexStr = str;
    let key = CryptoJS.enc.Utf8.parse(k);
    let iv = CryptoJS.enc.Utf8.parse(i);
    var decrypted = CryptoJS.AES.decrypt(encryptedHexStr, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
};
/**
 * web h5  网页
 * localStorage 存储
 */
export const ls = {
    get: (key) => {
        let datastr = localStorage.getItem(key);
        if (datastr !== undefined && datastr !== null) {
            if (datastr.indexOf('{') == 0 || datastr.indexOf('[') == 0) {
                return JSON.parse(datastr);
            }
            return datastr;
        }
        return '';
    },
    set: (key, data) => {
        let str = typeof data === 'string' ? data : JSON.stringify(data);
        localStorage.setItem(key, str);
    },
    cl: (key) => {
        key ? localStorage.removeItem(key) : localStorage.clear();
    },
};

/**
 * web h5  随机获得32位数字key
 * 传给后台做第一次的加解密拿取数据
 */
export const getRandomAesKey = () => {
    var str = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var n = 32,
        s = '';
    for (var i = 0; i < n; i++) {
        var rand = Math.floor(Math.random() * str.length);
        s += str.charAt(rand);
    }
    return s;
};
